import styled, { css } from "styled-components";
import ButtonComponent from "../button";

export const Form = styled.form`
    /* display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr)); */
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;

    /* @media only screen and (max-width: 600px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    } */
`;

export const FieldWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: 20px;

    @media (max-width: 500px) {
        flex-direction: column;
    }
`;

export const FieldContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const FieldSection = styled.div`
    width: 100%;
    max-width: ${({ $compact }) => $compact ? '400px' : '600px'};

    /* input[type="text"] {
        width: 100%;
    } */
`;

export const IncreaseDecreaseActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
`;

export const TableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    
    @media only screen and (min-width: 601px) {
        max-height: 300px;
        padding: 14px;
        border-radius: 1rem;
        background-color: var(--theme-color-tertiary);
        border: 1px solid var(--table-border-color);
    }

    @media only screen and (max-width: 600px) {
        max-height: 270px;
    }
`;

export const ConfigurationWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    /* max-height: ${props => props.$fromMakerChecker ? '42vh' : '56vh'}; */
    overflow-y: auto;
    background-color: var(--theme-color-tertiary);
    border: 1px solid var(--border-color);
    padding: 20px;
    border-radius: 1rem;

    @media (max-width: 600px) {
        /* max-height: 45vh; */
        padding: 10px;
    }
`;

export const FieldActions = styled.div`
    /* flex: 1; */
    /* background-color: red; */
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: center;
    gap: 10px;
`;

export const ConfiguredTag = styled(ButtonComponent)`
    pointer-events: none;
`;

export const Label = styled.label`
    display: flex;
    gap: 3px;
    margin-bottom: 5px;

    svg {
        width: 15px;
        height: auto;
    }
`;

export const ActionsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: end;
    gap: 10px;

`;

export const FormError = styled.p`
    ${({ $fullwidth }) => $fullwidth && css`
        width: 100%;
    `}
    color: var(--color-error);
    font-size: 11px;
    padding-top: 2px;
`;

export const EmptyWrapper = styled.div`
    /* background-color: var(--theme-color-tertiary); */
    /* border: 1px solid var(--table-border-color); */
    padding: 40px 0;
    border-radius: 1rem;
`;

